import React, { useEffect, useState } from 'react';
import Main from '../ServicesComponent/SeoService/Main'
import BestChoice from '../ServicesComponent/SeoService/BestChoice';
import StageProcess from '../ServicesComponent/SeoService/StageProcess';
import Faqs from '../HomeComponent/Faqs';

const SeoService = () => {
    const [offsetY, setOffsetY] = useState(0);

  const handleScroll = () => {
    setOffsetY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
    <div
        className="services-container"
        style={{
          backgroundPositionY: `${offsetY * 0.5}px`, // Adjust this multiplier to control the speed
        }}
      >
      <Main/>
      <BestChoice/>
      <StageProcess/>
      <Faqs/>
      </div>
    </>
  )
}

export default SeoService
